import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { VisibilityService } from '../services/visibility.service';
import { WorkflowsService } from '../services/workflows.service';
import { RequirementTypesService } from '../services/requerimenttypes.service';
import { DomainConfigComponent } from '@app/domain-config.component';
import { Module } from '@models/module';
import { NgxPermissionsService } from 'ngx-permissions';
import { brand } from '@app/branding/brand';
import { UsersService } from '@services/users.service';
import { LexgosignService } from '@services/lexgosign.service';
import { setForcePasswordChangeFlag } from '../util/auth/helpers';
import { applyClmSignModuleVisibility } from '@app/util/clm-sign.util';
import { filterModulesByAnyPermission } from '@app/util/module-visible.util';

@Component({
    selector: 'app-intro',
    templateUrl: './intro.component.html',
    styleUrls: ['./intro.component.scss'],
    standalone: false
})
export class IntroComponent implements OnInit, OnDestroy {

  visibilities = [];
  workflows = [];
  requirementTypes = [];
  firstVisibility = 0;
  moduleVisible: Module[] = [];
  readonly brandName = brand.name;
  /** Clase host para overrides de tamaño/contraste del logo en build TR. */
  readonly isTrBrand = brand.id === 'tr';
  private readonly destroy$ = new Subject<void>();

  constructor(
    private modalService: NgbModal,
    private _visibility: VisibilityService,
    private _workflows: WorkflowsService,
    private _requiremenTypes: RequirementTypesService,
    private domainConfigComponent: DomainConfigComponent,
    private permissionsService: NgxPermissionsService,
    private usersService: UsersService,
    private lexgosignService: LexgosignService,
    private router: Router) {      
    this.moduleVisible = this.domainConfigComponent.getModuleVisible();
  }

  ngOnInit() {
    this.usersService.getDataUser().pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data?.result?.forcePasswordChange) {
        setForcePasswordChangeFlag(true);
        this.router.navigate(['/change-password']);
        return;
      }
    });
    this._visibility.getVisibility().pipe(takeUntil(this.destroy$)).subscribe(resp => {
      this.visibilities = resp['result'];
      this.firstVisibility = this.visibilities[0].items[0].id;
    })

    this._workflows.getWorkflows().pipe(takeUntil(this.destroy$)).subscribe(resp => {
      this.workflows = resp['result'];
    });

    this._requiremenTypes.getRequirementTypes().pipe(takeUntil(this.destroy$)).subscribe(resp => {
      this.requirementTypes = resp['result'];
    });

    this.moduleVisible = filterModulesByAnyPermission(
      this.moduleVisible,
      (permission) => this.permissionsService.getPermission(permission)
    );
    this.applyClmSignGate(false);
    // isEnabled ya hace catchError(() => of(false)); no hace falta rama error.
    this.lexgosignService.isEnabled().pipe(takeUntil(this.destroy$)).subscribe((enabled) => {
      this.applyClmSignGate(!!enabled);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private applyClmSignGate(enabled: boolean): void {
    this.moduleVisible = applyClmSignModuleVisibility(this.moduleVisible, enabled);
  }

}
